<div class='container-lg mt-4'>
  <div class='row d-flex justify-content-center'>
    <div class='bubble-container col-12'>

      <div class='row mt-2 p-2 grey-background round-edges justify-content-center'>
        Generate keys to connect your ExactBlue data with other apps.
      </div>
      <!-- generate key button that triggers key name modal -->
      <div class='row mt-4 justify-content-end'>
        <button class='btn btn-primary mr-3 round-button' data-toggle='modal'
                data-target='#chooseKeyNameModal'>Generate Key
        </button>
      </div>

      <div class='row mt-2 align-items-center'>

        <div class='col-1 fit-content border-box d-none d-md-flex'>
          <div class='circle-background p-2 d-flex justify-content-center align-items-center'>
            <!--link icon svg-->
            <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' fill='currentColor' class='bi bi-link-45deg'
                 viewBox='0 0 16 16'>
              <path
                d='M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z'/>
              <path
                d='M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z'/>
            </svg>
          </div>

        </div>

        <div class='col'>
          <div class='row d-flex align-items-center'>
            <strong>Connect your data securely</strong>
            <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' class='bi bi-question-circle ml-1 text-dark'
                 viewBox='0 0 16 16'>
              <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/>
              <path
                d='M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z'/>
            </svg>
          </div>
          <div class='row'>
            <p class='text-dark'>
              You can connect your data on ExactBlue with other apps easily with Zapier. Check how <a
              href='https://zapier.com/how-it-works' target='_blank'>here</a>
            </p>
          </div>
        </div>

      </div>

      <div class='row mt-2 align-items-center'>

        <div class='col-1 fit-content border-box d-none d-md-flex'>
          <div class='circle-background p-2 d-flex justify-content-center align-items-center'>
            <!--link icon svg-->
            <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' fill='currentColor' class='bi bi-link-45deg'
                 viewBox='0 0 16 16'>
              <path
                d='M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z'/>
              <path
                d='M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z'/>
            </svg>
          </div>

        </div>

        <div class='col'>
          <div class='row d-flex align-items-center'>
            <strong>Copy your UID</strong>
          </div>
          <div class='row d-flex align-items-center'>
            <p class='text-dark mb-0'>
              You will need your UID to authenticate your data.
            </p>
            <button class='btn btn-primary mx-3 round-button' id='copy-uid-button' (click)='copyUidToClipboard()'>Copy UID
            </button>
          </div>
        </div>
      </div>

      <!-- table -->
      <div class='row mt-4'>
        <table class='table'>
          <thead class='w-100'>
          <tr>
            <th scope='col'>Name</th>
            <th scope='col'>Key</th>
            <th scope='col'>Issued Date</th>
            <th scope='col'>Status</th>
            <th scope='col'>Last Used</th>
            <th scope='col'></th>
          </tr>
          </thead>
          <tbody class='w-100' *ngIf='loaded && apiKeys && apiKeys.length > 0'>
          <tr *ngFor='let apiKey of apiKeys'>
            <th scope='row' class='table-row-head'>{{apiKey.name}}</th>
            <td class='d-flex align-items-center'>
              <strong>{{apiKey.visible ? apiKey.key : '**************************'}}</strong>
              <mat-icon class='pointer-cursor mx-2' (click)='apiKey.visible = !apiKey.visible'>remove_red_eye</mat-icon>
            </td>
            <td><strong>{{apiKey.issuedDateString}}</strong></td>
            <td *ngIf='apiKey.activated'>
              <div class='activated w-75 text-center rounded'><strong>ACTIVATED</strong></div>
            </td>
            <td *ngIf='!apiKey.activated'>
              <div class='deactivated w-75 text-center rounded'><strong>DEACTIVATED</strong></div>
            </td>
            <td><strong>{{apiKey.lastUsedString}}</strong></td>
            <td class='padding-top'>
              <!-- Menu button -->
              <strong>
                <button mat-icon-button [matMenuTriggerFor]='menu' aria-label='Example icon-button with a menu'>
                  <mat-icon class='mb-2'>more_horiz</mat-icon>
                </button>
                <mat-menu #menu='matMenu'>
                  <button mat-menu-item>
                    <span class='p-2'
                          (click)='updateKeyActivation(apiKey)'>{{!apiKey.activated ? "Activate" : "Deactivate"}}</span>
                  </button>
                  <button mat-menu-item>
                    <span class='p-2' data-toggle='modal' (click)='apiKeyDeleted = apiKey'
                          data-target='#deleteKeyModal'>Delete</span>
                  </button>
                </mat-menu>
              </strong>
            </td>
          </tr>
          </tbody>

          <!-- skeleton loader if not loaded -->
          <tbody class='w-100' *ngIf='!loaded'>
          <tr>
            <th scope='row' class='table-row-head'>
              <ngx-skeleton-loader count='1'></ngx-skeleton-loader>
            </th>
            <td>
              <ngx-skeleton-loader count='1'></ngx-skeleton-loader>
            </td>
            <td>
              <ngx-skeleton-loader count='1'></ngx-skeleton-loader>
            </td>
            <td>
              <ngx-skeleton-loader count='1'></ngx-skeleton-loader>
            </td>
            <td>
              <ngx-skeleton-loader count='1'></ngx-skeleton-loader>
            </td>
            <td>
              <ngx-skeleton-loader count='1'></ngx-skeleton-loader>
            </td>
          </tr>
          </tbody>

          <!-- no data message -->
          <tbody class='w-100' *ngIf='loaded && (!apiKeys || apiKeys.length === 0)'>
          <!-- centred text -->
          <tr>
            <th scope='row' class='table-row-head text-center' colspan='6'>
              <div class='text-center'>
                <p class='text-center'>No keys found, please create a new key by clicking on the "Generate Key" button.
                </p>
              </div>
            </th>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>

<!-- Choose API Key name modal -->
<div class='modal fade' id='chooseKeyNameModal' tabindex='-1' role='dialog' aria-labelledby='chooseKeyNameModalLabel'
     aria-hidden='true'>
  <div class='modal-dialog' role='document'>
    <div class='modal-content'>
      <div class='modal-header'>
        <h3 class='modal-title' id='chooseKeyNameModalLabel'><label for='keyName'>Name Your Key</label></h3>
        <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
      </div>
      <div class='modal-body pt-0'>
        <div class='row pt-0'>
          <div class='col pt-0'>
            <div class='form-group'>
              <input type='text' class='form-control' id='keyName' placeholder='Enter key name'
                     [(ngModel)]='generatedKeyName'>
              <!-- key name error -->
              <div class='text-danger mt-1' *ngIf='keyNameError'>
                Invalid key name
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='modal-footer'>
        <button type='button' class='btn btn-secondary round-button' data-dismiss='modal'>Close</button>
        <!-- create key button -->
        <button type='button' class='btn btn-primary round-button' (click)='generateKey()' *ngIf='generatedKeyName'
                data-dismiss='modal'>Create
        </button>
        <!-- create key button disabled -->
        <button type='button' class='btn btn-primary round-button' (click)='keyNameError = true'
                *ngIf='!generatedKeyName || generatedKeyName.length === 0'>Create
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Key Modal-->

<div class='modal fade' tabindex='-1' role='dialog' id='deleteKeyModal' aria-labelledby='deleteKeyModalLabel'
     aria-hidden='true'>
  <div class='modal-dialog' role='document'>
    <div class='modal-content'>
      <div class='modal-header p-1'>
        <h3 class='modal-title'>
          <mat-icon class='text-danger m-2'>delete</mat-icon>
          Delete Confirmation
        </h3>
        <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
      </div>
      <div class='modal-body'>
        <p>Are you sure you want to delete this key?</p>
        <p>You will not be able to authenticate with this key anymore.</p>
        <h4><label for='deleteText'><strong>Confirm by typing <span
          class='text-danger'>Delete</span> below.</strong></label></h4>
        <input id='deleteText' type='text' class='form-control w-100' [(ngModel)]='deleteConfirmationText'
               (ngModelChange)='this.deleteTextError = this.deleteConfirmationText !== "Delete"'>
        <p class='text-danger'
           *ngIf='deleteTextError && deleteModalSubmitted'>Incorrect value. Please type "Delete" to confirm deletion.</p>
      </div>
      <div class='modal-footer'>
        <!-- delete button disabled -->
        <button *ngIf='deleteTextError' type='button' class='btn btn-danger'
                (click)='deleteKey(apiKeyDeleted)'>Delete Forever
        </button>
        <!-- delete button -->
        <button *ngIf='!deleteTextError' type='button' class='btn btn-danger' data-dismiss='modal'
                (click)='deleteKey(apiKeyDeleted)'>Delete Forever
        </button>
        <button type='button' class='btn btn-secondary' data-dismiss='modal'>Cancel</button>
      </div>
    </div>
  </div>
</div>
